import React, { Component } from "react";
import domain from "../../../../../domain.js";
import axios from "axios";
import { Accordion, Radio } from "semantic-ui-react";
// import 'semantic-ui-css/semantic.min.css';
import CourseWiseFeedbackForm from "../Feedback/CourseWiseFeedbackForm";
import decode from "jwt-decode";
export default class CourseWiseFeedback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lecturer_name: "",
      topic: "",
      start_time: "",
      end_time: "",
      data: null,
      trainee_id: "",
      username: "",
      course_session_id: "",
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    const { id, username } = decode(localStorage.getItem("token"));
    axios
      .get(`${domain.DBServer}/get-session/${id}`)
      .then((result) => {
        this.setState({
          lecturer_name: result.data[0].lecturer_name,
          start_time: result.data[0].start_time,
          end_time: result.data[0].end_time,
          topic: result.data[0].title,
          course_session_id: result.data[0].course_session_id,
          data: result.data,
          trainee_id: id,
          username: username,
        });
      })
      .catch((error) => {
        console.error("error: ", error);
      });
  }
  handleChange = (e, { value }) => {
    this.setState({ course_session_id: value });
  };
  render() {
    let panels = null;
    // let label=null
    // console.log(this.state.course_session_id);
    if (this.state.data) {
      panels = this.state.data.map((result, i) => ({
        title: {
          content: (
            <Radio
              label={
                `Lecturer Name`
                  .join(``)
                  .result.lecturer_name.join(" ")
                  .result.title.join(" ")
                  .result.start_time.join(" ").result.end_time
              }
              name="radioGroup"
              value={result.course_session_id}
              onChange={this.handleChange}
              checked={
                this.state.course_session_id === result.course_session_id
              }
            />
          ),
          // <Label color='blue' content='session Time'/>,
          key: `title-${i}`,
        },
        content: {
          content: (
            <CourseWiseFeedbackForm
              trainee_id={this.state.trainee_id}
              course_session_id={this.state.course_session_id}
              content="session"
            />
          ),
          key: `content-${i}`,
        },
      }));
    }

    return (
      <div>
        <Accordion panels={panels} />
      </div>
    );
  }
}
